exports.components = {
  "component---src-pages-2022-survey-report-tsx": () => import("./../../../src/pages/2022-survey-report.tsx" /* webpackChunkName: "component---src-pages-2022-survey-report-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

